/** Nhóm chức năng hiển thị trên UI quản lý quyền sử dụng */

export const MODULE_CATEGORIES = [
  { key: "hrm", label: "HRM — Nhân sự" },
  { key: "crm", label: "CRM — Kinh doanh" },
  { key: "finance", label: "Tài chính" },
  { key: "elearning", label: "eLearning" },
  { key: "reports", label: "Báo cáo" },
  { key: "settings", label: "Cài đặt & Hệ thống" },
];

export const FEATURE_GROUP_CATALOG = [
  { key: "hrm_dashboard", labelVi: "Dashboard", category: "hrm", description: "Xem tổng quan module nhân sự.", actions: ["R"] },
  { key: "hrm_branches", labelVi: "Chi nhánh", category: "hrm", description: "Quản lý danh sách chi nhánh.", actions: ["R", "C", "U", "D"] },
  { key: "hrm_employees", labelVi: "Nhân viên", category: "hrm", description: "Hồ sơ NV; I = dữ liệu nhạy cảm (CCCD, lương…).", actions: ["R", "C", "U", "D", "E", "I"] },
  { key: "hrm_plans", labelVi: "Kế hoạch", category: "hrm", description: "Lập và theo dõi kế hoạch.", actions: ["R", "C", "U", "D"] },
  { key: "hrm_tasks", labelVi: "Công việc", category: "hrm", description: "Đăng ký, báo cáo, duyệt công việc.", actions: ["R", "C", "U", "A", "D", "E"] },
  { key: "hrm_attendance", labelVi: "Chấm công", category: "hrm", description: "Chấm công, xác nhận công.", actions: ["R", "C", "U", "A"] },
  { key: "hrm_overtime", labelVi: "Tăng ca", category: "hrm", description: "Đăng ký và duyệt tăng ca.", actions: ["R", "C", "U", "A"] },
  { key: "hrm_business_trip", labelVi: "Công tác", category: "hrm", description: "Đơn công tác và phê duyệt.", actions: ["R", "C", "U", "A"] },
  { key: "hrm_on_leave", labelVi: "Nghỉ phép", category: "hrm", description: "Đơn nghỉ phép và phê duyệt.", actions: ["R", "C", "U", "A"] },
  { key: "hrm_payslip", labelVi: "Bảng lương cá nhân", category: "hrm", description: "NV xem phiếu lương của mình.", actions: ["R"] },
  { key: "hrm_documents", labelVi: "Thư viện tài liệu", category: "hrm", description: "Tài liệu nội bộ HR.", actions: ["R", "C", "U", "D"] },
  { key: "hrm_signing", labelVi: "Trình ký", category: "hrm", description: "Luồng trình ký văn bản.", actions: ["R", "C", "U", "A"] },
  { key: "crm_dashboard", labelVi: "Dashboard", category: "crm", description: "Tổng quan CRM.", actions: ["R"] },
  { key: "crm_customers", labelVi: "Khách hàng", category: "crm", description: "Quản lý khách hàng / trường (gồm chọn Tags trên form).", actions: ["R", "C", "U", "D"] },
  { key: "crm_teacher_accounts", labelVi: "Giáo viên đối tác", category: "crm", description: "Tài khoản GV trường.", actions: ["R", "C", "U"] },
  { key: "crm_contact_history", labelVi: "Lịch sử liên hệ", category: "crm", description: "Nhật ký chăm sóc KH.", actions: ["R", "C", "U"] },
  { key: "crm_contracts", labelVi: "Hợp đồng", category: "crm", description: "Hợp đồng và phụ lục.", actions: ["R", "C", "U", "D"] },
  { key: "crm_documents", labelVi: "Hồ sơ liên kết", category: "crm", description: "Chứng từ gắn hợp đồng.", actions: ["R", "C", "U", "D"] },
  { key: "finance_dashboard", labelVi: "Dashboard", category: "finance", description: "Tổng quan tài chính.", actions: ["R"] },
  { key: "finance_advance", labelVi: "Đề nghị tạm ứng", category: "finance", description: "Tạo, duyệt, quyết toán tạm ứng.", actions: ["R", "C", "U", "A", "D"] },
  { key: "finance_payment", labelVi: "Đề nghị thanh toán", category: "finance", description: "Thanh toán chi phí NCC.", actions: ["R", "C", "U", "A"] },
  { key: "finance_salary", labelVi: "Lương nhân sự", category: "finance", description: "Bảng lương, duyệt chi trả.", actions: ["R", "C", "U", "A"] },
  { key: "finance_income_expenditure", labelVi: "Quản lý thu-chi", category: "finance", description: "Sổ thu chi.", actions: ["R", "C", "U", "D"] },
  { key: "finance_invoices", labelVi: "Hóa đơn", category: "finance", description: "Hóa đơn bán hàng / công nợ.", actions: ["R", "C", "U", "D"] },
  { key: "finance_receipts", labelVi: "Phiếu thu", category: "finance", description: "Phiếu thu tiền học viên.", actions: ["R", "C", "U", "D"] },
  { key: "elearning_dashboard", labelVi: "Dashboard", category: "elearning", description: "Tổng quan đào tạo.", actions: ["R"] },
  { key: "elearning_documents", labelVi: "Tài liệu học tập", category: "elearning", description: "Kho tài liệu.", actions: ["R", "C", "U", "D"] },
  { key: "elearning_subjects", labelVi: "Môn học", category: "elearning", description: "Danh mục môn học.", actions: ["R", "C", "U", "D"] },
  { key: "elearning_courses", labelVi: "Khóa học", category: "elearning", description: "Khóa học và chương trình.", actions: ["R", "C", "U", "D"] },
  { key: "elearning_lessons", labelVi: "Bài học", category: "elearning", description: "Nội dung bài giảng.", actions: ["R", "C", "U", "D"] },
  { key: "elearning_classes", labelVi: "Lớp học", category: "elearning", description: "Lớp và lịch học.", actions: ["R", "C", "U", "D"] },
  { key: "elearning_students", labelVi: "Học viên", category: "elearning", description: "Hồ sơ học viên.", actions: ["R", "C", "U", "D"] },
  { key: "elearning_attendance", labelVi: "Điểm danh", category: "elearning", description: "Điểm danh buổi học.", actions: ["R", "C", "U"] },
  { key: "elearning_results", labelVi: "Kết quả học tập", category: "elearning", description: "Điểm số, đánh giá.", actions: ["R", "C", "U"] },
  { key: "elearning_calendar", labelVi: "Thời khóa biểu", category: "elearning", description: "Lịch giảng dạy.", actions: ["R", "C", "U"] },
  { key: "elearning_certificates", labelVi: "Giấy chứng nhận", category: "elearning", description: "Yêu cầu & quản lý chứng nhận.", actions: ["R", "C", "U"] },
  { key: "reports_tasks", labelVi: "Công việc hàng ngày", category: "reports", description: "Báo cáo task, xuất Excel.", actions: ["R", "E"] },
  { key: "reports_finance", labelVi: "Báo cáo tài chính", category: "reports", description: "Dòng tiền, thu tiền & công nợ.", actions: ["R", "E"] },
  { key: "settings_admin", labelVi: "Phân quyền & vai trò", category: "settings", description: "Quản lý quyền sử dụng (admin).", actions: ["R", "C", "U", "D", "E"] },
  { key: "settings_signature", labelVi: "Chữ ký & con dấu", category: "settings", description: "Ảnh chữ ký, con dấu.", actions: ["R", "U"] },
  { key: "system_notify", labelVi: "Quản lý thông báo", category: "settings", description: "Thông báo toàn hệ thống.", actions: ["R", "C", "U", "D"] },
  { key: "system_version", labelVi: "Phiên bản ứng dụng", category: "settings", description: "Quản lý phiên bản PWA.", actions: ["R", "U"] },
];

export const LEGACY_GROUP_EXPAND = {
  tasks: ["hrm_tasks", "reports_tasks"],
  hrm: FEATURE_GROUP_CATALOG.filter((g) => g.category === "hrm").map((g) => g.key),
  finance: FEATURE_GROUP_CATALOG.filter((g) => g.category === "finance" || g.key === "reports_finance").map((g) => g.key),
  crm: FEATURE_GROUP_CATALOG.filter((g) => g.category === "crm").map((g) => g.key),
  elearning: FEATURE_GROUP_CATALOG.filter((g) => g.category === "elearning").map((g) => g.key),
  reports: ["reports_tasks", "reports_finance"],
  settings: FEATURE_GROUP_CATALOG.filter((g) => g.category === "settings").map((g) => g.key),
};

export function expandLegacyGrants(raw) {
  if (!raw || typeof raw !== "object") return {};
  const valid = ["C", "R", "U", "D", "E", "I", "A"];
  const knownKeys = new Set(FEATURE_GROUP_CATALOG.map((g) => g.key));
  const out = {};
  for (const [key, actions] of Object.entries(raw)) {
    const list = Array.isArray(actions) ? actions.filter((a) => valid.includes(a)) : [];
    if (!list.length) continue;
    if (knownKeys.has(key)) {
      out[key] = [...new Set([...(out[key] || []), ...list])].sort();
    } else if (LEGACY_GROUP_EXPAND[key]) {
      for (const target of LEGACY_GROUP_EXPAND[key]) {
        out[target] = [...new Set([...(out[target] || []), ...list])].sort();
      }
    }
  }
  return out;
}

export const SCOPE_LEVEL_OPTIONS = [
  { value: "self", label: "Cá nhân", hint: "Chỉ dữ liệu do mình tạo hoặc được giao." },
  { value: "department", label: "Theo bộ phận", hint: "Dữ liệu trong cùng bộ phận." },
  { value: "branch", label: "Theo chi nhánh", hint: "Toàn chi nhánh — GĐ CN, kế toán CN." },
  { value: "company", label: "Toàn công ty", hint: "Không giới hạn CN/BP — Super Admin." },
];

export const ACTION_LABELS = {
  C: "Tạo", R: "Xem", U: "Sửa", D: "Xóa", E: "Xuất", A: "Duyệt", I: "Nhạy cảm",
};

export const SOURCE_MODE_OPTIONS = [
  {
    value: "preset",
    title: "Mẫu mặc định hệ thống",
    description: "Chọn loại chức vụ phổ biến. Hệ thống điền sẵn quyền — bạn chỉ tinh chỉnh.",
    badge: "Khuyến nghị",
  },
  {
    value: "clone",
    title: "Sao chép quyền có sẵn",
    description: "Copy quyền từ chức vụ đã tạo. Tiện khi nhân bản sang BP/CN khác.",
    badge: "Nhanh",
  },
  {
    value: "manual",
    title: "Tự cấu hình",
    description: "Không dùng mẫu — bật từng quyền thủ công.",
    badge: null,
  },
];
